<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Peter Bishop moved to Dublin in Ireland from the UK in the early 1990s. He worked in the food industry before starting a new career in IT after being made redundant in the 2009 Recession. He inherited a love of reading from his parents. From childhood, he has had a passionate interest in History. This helped him immensely in the research of his family tree, a project lasting over 25 years. His wide and deep interests and knowledge of history, economics and technology are reflected in his writing. He has a basic fluency in French.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?65928e5a